module.exports = __webpack_public_path__ + "static/media/isdoctorplan-spine-pain2@2x.f9648f98.png";